// libs
import { createContext, useContext } from 'react';

interface IDetailsContext {
  galleryInZoomView: boolean;
  openImageGalleryInZoomView: VoidFunction;
  closeImageGalleryInZoomView: VoidFunction;
  isScrollAtTop: boolean;
}

const EMPTY_FUNC = () => {
  /** DO NOTHING */
};

const initialValue: IDetailsContext = {
  galleryInZoomView: false,
  openImageGalleryInZoomView: EMPTY_FUNC,
  closeImageGalleryInZoomView: EMPTY_FUNC,
  isScrollAtTop: false,
};

const DetailsContext = createContext(initialValue);

export const useDetailsContext = () => useContext(DetailsContext);

export default DetailsContext;
